import { useEffect, useState } from "react"
import Sliderprice from "../components/Slider"
import axios from "axios"
import MobileCard from "../components/Mobilecard"
import Header from "../components/layout/Header"
import CategoryList from "../components/home/CategoryList"
import { AiFillStar } from "react-icons/ai"
import { Link } from "react-router-dom"

function Apple() {
    const [product, setProduct] = useState([])
    const [sort, setSort] = useState("")

    // High-fidelity fallback data for demonstration
    const fallbackProducts = [
        {
            id: 'a1',
            category: 'apple',
            name: "Apple iPhone 15 Pro Max (Natural Titanium, 256 GB)",
            image: "https://rukminim2.flixcart.com/image/312/312/xif0q/mobile/8/z/w/-original-imagtc2fgnxb6ycx.jpeg?q=70",
            star: 4.7,
            rating: "2,456 Ratings",
            _13vcmD: "&",
            rating2: "189 Reviews",
            rgWa7D: "256 GB ROM",
            display: "17.02 cm (6.7 inch) Super Retina XDR Display",
            camera: "48MP + 12MP + 12MP | 12MP Front Camera",
            battery: "A17 Pro Chip, 6 Core Processor",
            warranty: "1 Year Warranty for Phone and 6 Months Warranty for In-Box Accessories",
            price: "₹1,48,900",
            priceA: 148900,
            cuttoff: "₹1,59,900",
            off: "6% off",
            delivery: "Free delivery",
            assured: "https://static-assets-web.flixcart.com/fk-p-linchpin-web/fk-cp-zion/img/fa_62ec6a.png",
            bank: "Bank Offer",
            processor: "A17 Pro Chip, 6 Core Processor"
        },
        {
            id: 'a2',
            category: 'apple',
            name: "Apple iPhone 14 (Blue, 128 GB)",
            image: "https://rukminim2.flixcart.com/image/312/312/xif0q/mobile/3/5/l/-original-imaghx9qngqbhebs.jpeg?q=70",
            star: 4.6,
            rating: "2,15,678 Ratings",
            _13vcmD: "&",
            rating2: "12,456 Reviews",
            rgWa7D: "128 GB ROM",
            display: "15.49 cm (6.1 inch) Super Retina XDR Display",
            camera: "12MP + 12MP | 12MP Front Camera",
            battery: "A15 Bionic Chip, 6 Core Processor",
            warranty: "1 Year Warranty for Phone and 6 Months Warranty for In-Box Accessories",
            price: "₹58,999",
            priceA: 58999,
            cuttoff: "₹69,900",
            off: "15% off",
            delivery: "Free delivery",
            assured: "https://static-assets-web.flixcart.com/fk-p-linchpin-web/fk-cp-zion/img/fa_62ec6a.png",
            bank: "Bank Offer",
            processor: "A15 Bionic Chip, 6 Core Processor"
        }
    ];

    useEffect(() => {
        const getData = async () => {
            try {
                let res = await axios.get(`http://localhost:3004/posts?category=apple&_sort=rating&_order=${sort}`)
                if (res.data && res.data.length > 0) {
                    setProduct(res.data)
                } else {
                    setProduct(fallbackProducts)
                }
            } catch (error) {
                console.error("Error fetching data, using fallback:", error)
                setProduct(fallbackProducts)
            }
        }
        getData()
    }, [sort])

    const handleHighToLow = () => setSort("desc")
    const handleLowToHigh = () => setSort("asc")

    return (
        <div style={{ paddingTop: '128px', backgroundColor: '#f1f2f4', minHeight: '100vh' }}>
            <Header />
            <CategoryList />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '0 16px' }}>
                {/* Brand Banner */}
                <div style={{ width: '100%', marginBottom: '16px', borderRadius: '4px', overflow: 'hidden', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                    <img
                        src="https://rukminim1.flixcart.com/fk-p-flap/1600/270/image/3b12ea642f89f924.jpg?q=20"
                        alt="Apple Banner"
                        style={{ width: '100%', display: 'block' }}
                    />
                </div>

                {/* Breadcrumbs */}
                <div style={{ padding: '8px 0', fontSize: '12px', color: '#878787' }}>
                    Home &gt; Mobiles &gt; Apple Mobiles
                </div>

                <div style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
                    {/* Sidebar */}
                    <div style={{ width: '280px', flexShrink: 0, backgroundColor: 'white', padding: '16px', borderRadius: '4px', height: 'fit-content', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        <p style={{ fontSize: '18px', fontWeight: '700', margin: '0 0 16px 0', color: '#1a1a1a' }}>Filters</p>

                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ fontSize: '14px', fontWeight: '800', margin: '0 0 10px 0', textTransform: 'uppercase' }}>Categories</p>
                            <p style={{ fontSize: '14px', color: '#878787', margin: '0 0 4px 0', cursor: 'pointer' }}>Mobiles & Accessories</p>
                            <p style={{ fontSize: '14px', fontWeight: '700', color: 'var(--color-primary)', margin: '0 0 0 12px' }}>Mobiles</p>
                        </div>

                        <hr style={{ border: 'none', borderBottom: '1px solid #f0f0f0', margin: '16px 0' }} />

                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ fontSize: '14px', fontWeight: '800', margin: '0 0 15px 0', textTransform: 'uppercase' }}>Price</p>
                            <Sliderprice initialvalue={50000} value1={30000} value2={80000} value3={150000} />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '15px' }}>
                                <select style={{ flex: 1, padding: '6px', border: '1px solid #e0e0e0', borderRadius: '2px', fontSize: '13px' }}>
                                    <option value="Min">Min</option>
                                    <option value='30000'>₹30,000</option>
                                    <option value='50000'>₹50,000</option>
                                </select>
                                <span style={{ color: '#878787' }}>to</span>
                                <select style={{ flex: 1, padding: '6px', border: '1px solid #e0e0e0', borderRadius: '2px', fontSize: '13px' }}>
                                    <option value="150000">₹1,50,000+</option>
                                </select>
                            </div>
                        </div>

                        <hr style={{ border: 'none', borderBottom: '1px solid #f0f0f0', margin: '16px 0' }} />

                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ fontSize: '14px', fontWeight: '800', margin: '0 0 12px 0', textTransform: 'uppercase' }}>Customer Rating</p>
                            {[4, 3].map(val => (
                                <div key={val} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: '8px' }} onClick={handleHighToLow}>
                                    <input type="checkbox" style={{ cursor: 'pointer' }} />
                                    <span style={{ fontSize: '14px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        {val} <AiFillStar style={{ color: '#26a541', fontSize: '14px' }} /> & above
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Main Content Area */}
                    <div style={{ flex: 1 }}>
                        {/* Sort Header */}
                        <div style={{ backgroundColor: 'white', padding: '12px 16px', borderRadius: '4px', marginBottom: '8px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <span style={{ fontSize: '14px', fontWeight: '700' }}>Sort By</span>
                                {['Relevance', 'Popularity', 'Price -- Low to High', 'Price -- High to Low', 'Newest First'].map((t, i) => (
                                    <span
                                        key={i}
                                        style={{
                                            fontSize: '14px',
                                            cursor: 'pointer',
                                            color: i === 0 ? 'var(--color-primary)' : '#212121',
                                            fontWeight: i === 0 ? '700' : '400',
                                            borderBottom: i === 0 ? '2px solid var(--color-primary)' : 'none',
                                            paddingBottom: '2px'
                                        }}
                                        onClick={t.includes('Low') ? handleLowToHigh : t.includes('High') ? handleHighToLow : undefined}
                                    >
                                        {t}
                                    </span>
                                ))}
                            </div>
                        </div>

                        {/* Product List */}
                        <div style={{ backgroundColor: 'white', borderRadius: '4px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                            {product.length > 0 ? product.map(el => (
                                <Link key={el.id} to={`/singleproductpage/${el.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <MobileCard
                                        name={el.name}
                                        image={el.image}
                                        star={el.star}
                                        rating={el.rating}
                                        and={el._13vcmD}
                                        review={el.rating2}
                                        ram={el.rgWa7D}
                                        display={el.display}
                                        camera={el.camera}
                                        battery={el.battery}
                                        price={el.price}
                                        cuttoff={el.cuttoff}
                                        off={el.off}
                                        warranty={el.warranty}
                                        assured={el.assured}
                                        delivery={el.delivery}
                                        bank={el.bank === "Bank Offer" ? "Bank Offer" : `Upto ₹${Math.ceil(el.priceA * 0.3)} on Exchange`}
                                        processor={el.processor}
                                    />
                                </Link>
                            )) : (
                                <div style={{ padding: '40px', textAlign: 'center' }}>
                                    <p style={{ color: '#878787' }}>No products found matching your selection.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Apple;